import { ElectricityData } from '@/api/energyOverview';
export const colors = ['#FF6D2C', '#CE90D1', '#0DB6D9', '#63BC7F'];

// 用电饼状图配置
export const getElectricityChartOption = (electricityData: ElectricityData) => {
  if (!electricityData) return {};
  const data = [
    { name: '尖峰', value: Math.abs(electricityData?.summit?.value || 0) },
    { name: '峰', value: Math.abs(electricityData?.peak?.value || 0) },
    { name: '平', value: Math.abs(electricityData?.plain?.value || 0) },
    { name: '谷', value: Math.abs(electricityData?.valley?.value || 0) },
  ];

  return {
    tooltip: { show: false },
    legend: { show: false },
    color: colors,
    series: [
      {
        type: 'pie',
        radius: ['42%', '52%'],
        center: ['50%', '50%'],
        itemStyle: {
          color: '#E3EFFF',
        },
        label: { show: false },
        data: data,
      },
      {
        type: 'pie',
        radius: ['50%', '90%'],
        center: ['50%', '50%'],
        label: { show: false },
        padAngle: 1,
        data: data,
      },
      {
        type: 'pie',
        radius: ['90%', '100%'],
        center: ['50%', '50%'],
        itemStyle: {
          color: '#E3EFFF',
        },
        label: { show: false },
        data: data,
      },
    ],
  };
};
